import { call, put } from 'redux-saga/effects';
import * as _ from 'underscore';

import { requestFailed } from '~src/app/actions/RequestFailedAction';
import { Messages } from '~src/codegen/Localize';
import { PublishedConnectionTaskTableInfo } from '~src/publishedConnection/types/PublishedConnectionTaskTableInfo';
import { PublishedConnectionTables } from '~src/publishedConnectionTable/resources/PublishedConnectionTables';
import { IContentInfo } from '~src/ts/models/IContentInfo';
import { IPublishedConnectionTable } from '~src/ts/ServerApi/types/IPublishedConnectionTable';

import { PublishedConnectionTableExtractsRefreshNowAction } from '../actions/PublishedConnectionTableExtractsRefreshNowAction';
import { openPublishedConnectionTableRefreshNowDialogDialog } from '../components/PublishedConnectionTableExtractsRefreshNowDialog';

function allItemsFromSamePublishedConnection(targetItems: IContentInfo[]): boolean {
  if (targetItems.length >= 1) {
    const publishedConnectionId = (targetItems[0] as unknown as IPublishedConnectionTable).publishedConnectionId;
    return _.all(targetItems, (item => (item as unknown as IPublishedConnectionTable).publishedConnectionId === publishedConnectionId));
  }
  return false;
}

export function* handlePublishedConnectionTableRefreshNowExtract(action: PublishedConnectionTableExtractsRefreshNowAction) {
  const { selectedContent } = action;
  if (action.selectedContent.length === 0) {
    return;
  }

  const publishedConnectionId = (selectedContent[0] as unknown as IPublishedConnectionTable).publishedConnectionId;
  if (!publishedConnectionId || !allItemsFromSamePublishedConnection(selectedContent)) {
    // all content should be from same pconn
    yield call(PublishedConnectionTables.popError, Messages.publishedConnectionTableExtractsRefreshNowError());
  }
  const tables: ReadonlyArray<PublishedConnectionTaskTableInfo> = action.selectedContent.map(item => ({
    alias: item.name,
    luid: item.luid
  }));

  try {
    yield call(openPublishedConnectionTableRefreshNowDialogDialog, publishedConnectionId, tables);
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}
